<template>
  <nav
    class="navbar navbar-expand-md navbar-dark fixed-top bg-dark"
    style="margin: unset !important; background-color: #000 !important"
  >
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarCollapse"
      aria-controls="navbarCollapse"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <img
      src="/assets/logo/logo-sq.svg?"
      style="height: 49px; cursor: pointer"
      alt=""
    />
    <label
      class="mx-4"
      style="
        color: #fff;
        cursor: pointer;
        font-family: monospace;
        font-weight: bold;
      "
    >
      4X4EpicRides
    </label>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link
            :to="{ name: 'PublicMapHome' }"
            class="nav-link text-light"
          >
            <i class="bi bi-house mx-1"></i>
            {{ $t("home") }}
          </router-link>
        </li>

        <li class="nav-item">
          <router-link
            :to="{ name: 'PublicAgahi' }"
            class="nav-link text-light"
          >
            <i class="bi bi-caret-left-fill mx-1"></i>
            {{ $t("آگهی") }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'PublicJobs-Search-Cv' }"
            class="nav-link text-light"
          >
            <i class="bi bi-caret-left-fill mx-1"></i>
            {{ $t("کاریابی") }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'PublicEducational' }"
            class="nav-link text-light"
          >
            <i class="bi bi-caret-left-fill mx-1"></i>
            {{ $t("آموزشی") }}
          </router-link>
        </li>

        <li class="nav-item">
          <router-link :to="{ name: 'PublicApi' }" class="nav-link text-light">
            <i class="bi bi-caret-left-fill mx-1"></i>
            {{ $t("APIs") }}
          </router-link>
        </li>

        <li class="nav-item">
          <router-link
            :to="{ name: 'PublicMapRouter' }"
            class="nav-link text-light"
          >
            <i class="bi bi-caret-left-fill mx-1"></i>
            {{ $t("مسیریاب") }}
          </router-link>
        </li>

        <!--
        <li class="nav-item">
          <router-link
            :to="{ name: 'PublicGroupList' }"
            class="nav-link text-light"
          >
            <i class="bi bi-caret-left-fill mx-1"></i>
            {{ $t("reports") }}
          </router-link>
        </li>
      -->
        <li class="nav-item">
          <router-link
            :to="{ name: 'PublicPrivacyPolicy' }"
            class="nav-link text-light"
          >
            <i class="bi bi-caret-left-fill mx-1"></i>
            {{ $t("privacy") }}
          </router-link>
        </li>

        <li class="nav-item">
          <router-link
            :to="{ name: 'PublicAbout' }"
            class="nav-link text-light"
          >
            <i class="bi bi-caret-left-fill mx-1"></i>
            {{ $t("about_us") }}
          </router-link>
        </li>

        <li class="nav-item">
          <router-link
            :to="{ name: 'PublicContactUs' }"
            class="nav-link text-light"
          >
            <i class="bi bi-caret-left-fill mx-1"></i>
            {{ $t("contact_us") }}
          </router-link>
        </li>
      </ul>
      <a href="/user/" class="btn btn-success my-2 my-sm-0">
        <i class="bi bi-person"></i>
        ورود کاربران
      </a>
    </div>
  </nav>
</template>